<template>
  <div data-testid="notifications-container">
    <button
      v-if="notificationsCounter > 0"
      class="button-badge"
      @click="openNotificationCentral"
    >
      <BadgeCounterFoundation :value="notificationsCounter" />
    </button>
    <ButtonIconContextual
      v-else
      label=""
      data-testid="notifications-button"
      icon="DA0060"
      @click.native="openNotificationCentral"
    />
    <NotificationCentral
      :is-open="showNotificationsCentral"
      :unread-counter="notificationsCounter"
      @close="showNotificationsCentral = false"
      @clear-unread="clearUnread"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from 'vue';

import {
  ButtonIconContextual,
  BadgeCounterFoundation
} from '@warrenbrasil/nebraska-web';

import { NotificationCentral } from '@/modules/common/components/NotificationCentral';
import { getNotificationsCounter } from '@/modules/common/services/new-notifications';

const notificationsCounter = ref<number>(0);
const showNotificationsCentral = ref<boolean>(false);

onBeforeMount(async () => {
  await fetchNotificationsCounter();
});

const openNotificationCentral = () => {
  showNotificationsCentral.value = true;
};

const clearUnread = () => {
  notificationsCounter.value = 0;
};

const fetchNotificationsCounter = async () => {
  try {
    const data = await getNotificationsCounter();
    notificationsCounter.value = data.pendingReads;
  } catch (error) {
    console.log(error);
  }
};
</script>

<style lang="less" scoped>
.button-badge {
  width: 48px;
  height: 48px;
  border-radius: @size-radius-max;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transition: opacity 0.5s;
    opacity: 0.5;
  }
}
</style>
